module.exports = __webpack_public_path__ + "img/intro-bg-active.40dfe155.png";